
<template>
    <svg width="26" height="26" viewBox="0 0 26 26" fill="#151515" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.4715 3.54412C12.8042 3.38113 13.1958 3.38113 13.5285 3.54412L25.3238 9.32238C25.474 9.39215 25.6068 9.49203 25.7141 9.61406C25.8923 9.8168 26 10.0807 26 10.3692V17.3166C26 17.9561 25.4709 18.4745 24.8182 18.4745C24.1655 18.4745 23.6364 17.9561 23.6364 17.3166V12.2428L13.5285 17.1944C13.1958 17.3574 12.8042 17.3574 12.4715 17.1944L0.653293 11.4049C0.252912 11.2088 0 10.8078 0 10.3692C0 9.93067 0.252912 9.52973 0.653293 9.33359L12.4715 3.54412ZM22.1756 10.3692L13 5.87434L3.82444 10.3692L13 14.8642L22.1756 10.3692Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.96199 11.6328C6.60979 11.6328 7.13493 12.1627 7.13493 12.8163V18.2189C8.6234 19.5158 10.7712 20.2132 12.9996 20.2132C15.228 20.2132 17.3758 19.5158 18.8643 18.2189V12.8163C18.8643 12.1627 19.3894 11.6328 20.0372 11.6328C20.685 11.6328 21.2101 12.1627 21.2101 12.8163V18.7338C21.2101 19.0477 21.0865 19.3487 20.8666 19.5707C18.8374 21.6181 15.8715 22.5802 12.9996 22.5802C10.1277 22.5802 7.16175 21.6181 5.13261 19.5707C4.91264 19.3487 4.78906 19.0477 4.78906 18.7338V12.8163C4.78906 12.1627 5.3142 11.6328 5.96199 11.6328Z"
        />
    </svg>
</template>
<script>
export default {
    name: "PublicHatIcon"
}
</script>
